import { backendCall, createApiCall } from '@reducers/utils';
import type { AppDispatch } from '@reducers/utils/types';
import type {
  AcquireEntityDetailsParams,
  GetErpFieldsParams,
  AcquireEntityDetailsFromReplicaResponse,
  ErpFieldsResponse,
} from './types';

// Re-export types for consumers
export type {
  AcquireEntityDetailsParams,
  GetErpFieldsParams,
  AcquireEntityDetailsFromReplicaResponse,
  ErpFieldsResponse,
} from './types';

// === Thunks ===

export const acquireEntityDetailsFromReplica = (data: AcquireEntityDetailsParams) => async (dispatch: AppDispatch) => {
  return await dispatch(
    backendCall(createApiCall((api) => api.erp.acquireEntityDetailsFromReplica, { params: data }))
  );
};

export const getErpFields = (data: GetErpFieldsParams) => async (dispatch: AppDispatch) => {
  return await dispatch(
    backendCall(createApiCall((api) => api.erp.getErpFields, { params: data }))
  );
};
